import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks";
import { httpClient } from "@/lib/http";
import {
  CompanyInformation,
  CreateOrUpdateCompanyInformationRequest,
  HttpResponse,
} from "@/types";

export function useUpdateCompanyInformation() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({
      companyInformationId,
      updateCompanyInformationRequest,
    }: {
      companyInformationId: string;
      updateCompanyInformationRequest: CreateOrUpdateCompanyInformationRequest;
    }) => {
      const path = `companies/${currentCompanyId}/company-informations/${companyInformationId}`;
      const res = await httpClient.patch<
        CompanyInformation,
        HttpResponse<CompanyInformation>,
        CreateOrUpdateCompanyInformationRequest
      >(path, updateCompanyInformationRequest);

      return res.data;
    },
  });

  return mutation;
}
